import { toUpper } from "lodash";
import styles from "components/product/detail/kind/Kind.module.scss";

const Kind = ({
  kind
}) => {
    if(!kind){ return ""; }
    return (
        <span 
            className={`${styles.kind} ${styles['item-'+toUpper(kind.hash)]}`}>
                {kind.name}
            </span>          
    );
};

export default Kind;
